import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=2dfb1aff&scoped=true&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=2dfb1aff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb1aff",
  null
  
)

export default component.exports